import script from "./ItemsSidebar.vue?vue&type=script&lang=jsx"
export * from "./ItemsSidebar.vue?vue&type=script&lang=jsx"

const __exports__ = script;

export default __exports__